(function () {
  var SIZE_RE = /^\s*(maat|maten|grootte|size)/i;

  function labelName(label) {
    if (!label) return '';
    if (label.hasAttribute('data-lmq-name')) return label.getAttribute('data-lmq-name');
    var txt = '';
    for (var i = 0; i < label.childNodes.length; i++) { var n = label.childNodes[i]; if (n.nodeType === 3) txt += n.textContent; }
    return (txt.trim() || label.textContent.trim());
  }

  function init() {
    var bar = document.querySelector('[data-lsa]');
    var root = document.querySelector('[data-lp]');
    if (!bar || !root || bar.dataset.lsaInit) return;
    var form = root.querySelector('.lp-form');
    var main = root.querySelector('.lp-atc');
    if (!form || !main) return;
    bar.dataset.lsaInit = '1';
    document.body.appendChild(bar);
    var price = bar.querySelector('[data-lsa-price]');
    var variant = bar.querySelector('[data-lsa-variant]');
    var btn = bar.querySelector('[data-lsa-btn]');
    var img = bar.querySelector('.lsa__img img');
    var labelD = btn.querySelector('.lsa__d'), labelM = btn.querySelector('.lsa__m');
    var defD = labelD.textContent, defM = labelM.textContent;
    var chooseText = bar.getAttribute('data-lsa-choose') || (document.documentElement.lang === 'sv' ? 'Välj storlek' : 'Kies je maat');

    var sizeFs = null;
    root.querySelectorAll('.lp-opt[data-lp-option]').forEach(function (f) {
      if (!sizeFs && SIZE_RE.test(labelName(f.querySelector('.lp-opt__label')))) sizeFs = f;
    });
    if (sizeFs && sizeFs.querySelectorAll('[data-value]').length < 2) sizeFs = null;
    var chosen = !sizeFs || /[?&]variant=/.test(window.location.search);

    function sync() {
      if (sizeFs) sizeFs.classList.toggle('lsa-nosize', !chosen);
      var p = root.querySelector('[data-lp-price]');
      if (p) price.innerHTML = p.innerHTML.replace(/lp-price__/g, 'lsa-price__');
      var sel = [];
      root.querySelectorAll('.lp-opt').forEach(function (f) {
        if (f === sizeFs && !chosen) return;
        var a = f.querySelector('.is-active[data-value]');
        if (a) sel.push(a.getAttribute('data-label') || a.getAttribute('data-value'));
      });
      variant.textContent = sel.join(' / ');
      var sw = root.querySelector('.lp-swatch.is-active img');
      if (sw && img) { img.removeAttribute('srcset'); img.src = sw.currentSrc || sw.src; }
      var disabled = main.hasAttribute('disabled');
      if (!chosen) {
        btn.disabled = false;
        labelD.textContent = chooseText; labelM.textContent = chooseText;
      } else if (disabled) {
        btn.disabled = true;
        var t = (main.querySelector('span') || main).textContent.trim();
        labelD.textContent = t; labelM.textContent = t;
      } else {
        btn.disabled = false;
        labelD.textContent = defD; labelM.textContent = defM;
      }
    }

    function goToSize() {
      var header = document.querySelector('.section-header');
      var offset = (header ? header.getBoundingClientRect().height : 0) + 24;
      var top = sizeFs.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      sizeFs.classList.remove('lsa-attn');
      void sizeFs.offsetWidth;
      sizeFs.classList.add('lsa-attn');
      clearTimeout(goToSize.t);
      goToSize.t = setTimeout(function () { sizeFs.classList.remove('lsa-attn'); }, 2600);
    }

    btn.addEventListener('click', function () {
      if (!chosen && sizeFs) { goToSize(); return; }
      if (main.hasAttribute('disabled')) return;
      main.click();
    });
    main.addEventListener('click', function (e) {
      if (!chosen && sizeFs) { e.preventDefault(); e.stopImmediatePropagation(); goToSize(); }
    }, true);
    root.addEventListener('click', function (e) {
      if (sizeFs && e.target.closest && e.target.closest('[data-value]') && sizeFs.contains(e.target)) {
        chosen = true;
        sizeFs.classList.remove('lsa-attn', 'lsa-nosize');
      }
      setTimeout(sync, 40);
    });
    try {
      new MutationObserver(function () {
        bar.classList.toggle('is-loading', main.classList.contains('loading'));
        sync();
      }).observe(main, { attributes: true, attributeFilter: ['class', 'disabled'] });
    } catch (e) {}
    sync();

    function setVisible(show) {
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      document.documentElement.classList.toggle('lsa-on', show);
    }
    var ticking = false;
    function check() {
      ticking = false;
      setVisible(form.getBoundingClientRect().bottom < 0);
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(check); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    check();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
